import { motion } from "framer-motion";
import { useTheme } from "../context/ThemeContext";
import { useLang } from "../context/LangContext";
import { translations } from "./translation";
import qr from "../img/qr.png";

export default function Footer() {
  const { theme } = useTheme();
  const { lang } = useLang();
  const t = translations;

  return (
    <footer
      style={{
        background: theme.bg,
        color: theme.text,
        padding: "60px 20px",
        borderTop: `1px solid ${theme.border}`,
      }}
    >
      <div
        style={{
          maxWidth: "1100px",
          margin: "0 auto",
          display: "flex",
          flexWrap: "wrap",
          justifyContent: "space-between",
          gap: "30px",
        }}
      >
        {/* LEFT */}
        <div>
          <h3 style={{ marginBottom: "10px", color: "#555" }}>
            {t.footerTitle[lang]}
          </h3>
          <p style={{ color: theme.secondaryText }}>{t.footerCountry[lang]}</p>
        </div>

        {/* CONTACTS */}
        <div style={{ display: "flex", gap: "20px", alignItems: "center" }}>
          {/* 📞 PHONE */}
          {/* <motion.a
            whileHover={{ scale: 1.1 }}
            href="tel:++996312626084"
            style={{
              textDecoration: "none",
              color: "#555",
              display: "flex",
              alignItems: "center",
              gap: "8px",
            }}
          >
            <span>📞</span>
            +996 (312) 62 60 84
          </motion.a> */}

          {/* QR CONTACTS */}
          <div
            style={{
              display: "flex",
              gap: "20px",
              alignItems: "center",
              flexWrap: "wrap",
            }}
          >
            {/* INSTAGRAM */}
            <motion.a
              whileHover={{ scale: 1.1 }}
              href="https://www.instagram.com/statistics.kg"
              target="_blank"
              style={{ textAlign: "center", textDecoration: "none" }}
            >
              <img
                src={qr}
                alt="instagram"
                style={{
                  width: "80px",
                  height: "80px",
                  borderRadius: "10px",
                  border: `1px solid ${theme.border}`,
                }}
              />
              <div style={{ fontSize: "12px", color: theme.secondaryText }}>
                Instagram
              </div>
            </motion.a>

            {/* TELEGRAM */}
            <motion.a
              whileHover={{ scale: 1.1 }}
              href="https://t.me"
              target="_blank"
              style={{ textAlign: "center", textDecoration: "none" }}
            >
              <img
                src={qr}
                alt="telegram"
                style={{
                  width: "80px",
                  height: "80px",
                  borderRadius: "10px",
                  border: `1px solid ${theme.border}`,
                }}
              />
              <div style={{ fontSize: "12px", color: theme.secondaryText }}>
                Telegram
              </div>
            </motion.a>

            {/* FACEBOOK */}
            <motion.a
              whileHover={{ scale: 1.1 }}
              href="https://facebook.com"
              target="_blank"
              style={{ textAlign: "center", textDecoration: "none" }}
            >
              <img
                src={qr}
                alt="facebook"
                style={{
                  width: "80px",
                  height: "80px",
                  borderRadius: "10px",
                  border: `1px solid ${theme.border}`,
                }}
              />
              <div style={{ fontSize: "12px", color: theme.secondaryText }}>
                Facebook
              </div>
            </motion.a>
          </div>
        </div>
      </div>

      {/* BOTTOM */}
      <div
        style={{
          marginTop: "40px",
          textAlign: "center",
          color: theme.secondaryText,
          fontSize: "14px",
        }}
      >
        © 2026 {t.footerCenter[lang]}
        <br />
        {t.footerDev[lang]}:{" "}
        <span style={{ color: "#555" }}>Айтбай Турабаев</span>
      </div>
    </footer>
  );
}
